/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Start: BridgeCommands.Command<
    Types.Gfn.Networktest.TestParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NetworkTest',
    method: 'Start',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const AuthTokenRequest: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NetworkTest',
    method: 'AuthTokenRequest',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const NetworkTestFinishedCallback: BridgeCommands.Command<
    {},
    Types.Gfn.Networktest.TestReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NetworkTest',
    method: 'NetworkTestFinishedCallback',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const UpdateAuthToken: BridgeCommands.Command<
    Types.Gfn.Networktest.UpdateAuthTokenParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NetworkTest',
    method: 'UpdateAuthToken',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ConfigureNetworkTestSettings: BridgeCommands.Command<
    Types.Gfn.Networktest.ConfigureNetworkTestSettingsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NetworkTest',
    method: 'ConfigureNetworkTestSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterCallback: BridgeCommands.Command<
    {},
    Types.Gfn.Networktest.RegisterCallbackReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NetworkTest',
    method: 'RegisterCallback',
    persistent: false
};

export const Networktest = {
Start,
AuthTokenRequest,
NetworkTestFinishedCallback,
UpdateAuthToken,
ConfigureNetworkTestSettings,
RegisterCallback
};
